const main_menu = [
  { key: "issues_manage", label: "Zgłoszenia oczekujące" },
  { key: "issues", label: "Zgłoszenia" },
  { key: "workers", label: "Pracownicy" },
  {
    key: "clients",
    label: "Klienci",
  },
  {
    key: "notes",
    label: "Notatki",
  },
  {
    key: "vacations",
    label: "Urlopy",
  },
  {
    key: "calendar",
    label: "Kalendarz",
  },
  {
    key: "issues_settlement",
    label: "Rozliczenia",
  },
];

export default main_menu;
